import * as yup from 'yup';

import { STRINGS } from '@/constants/strings';
import { countPhoneDigits } from '@/utils/helper';

export type SignUpFormValues = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  password: string;
  acceptedTerms: boolean;
};

const strings = STRINGS.auth.signUp;

export const signUpSchema = yup.object({
  firstName: yup.string().trim().required(strings.requiredFirstName),
  lastName: yup.string().trim().required(strings.requiredLastName),
  phone: yup
    .string()
    .required(strings.requiredPhone)
    // The field is pre-filled with the "+1" dial code; require a full number on top of it.
    .test('digits-range', STRINGS.mutatePlayer.validation.phoneNumberDigitsRange, val => {
      if (!val) return true;
      const n = countPhoneDigits(val);
      return n >= 10 && n <= 24;
    }),
  email: yup
    .string()
    .trim()
    .required(strings.requiredEmail)
    .matches(/[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/, strings.invalidEmail)
    .email(strings.invalidEmail),
  password: yup.string().required(strings.requiredPassword).min(8, strings.invalidPassword),
  acceptedTerms: yup.boolean().oneOf([true], strings.requiredTerms).required(strings.requiredTerms),
});
